module.exports = __webpack_public_path__ + "media/files/MarketplaceGuide-request-paylocity-integration-3d58381a1198cd6e62059e9f7097a43e.pdf";